import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.filter.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.for-each.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.push.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.to-string.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/web.dom-collections.for-each.js';
import { useRef } from 'react';

function createFormPubSub() {
  var _subscribers = [];
  var publish = function publish(value) {
    _subscribers.forEach(function (callback) {
      callback(value);
    });
  };
  var subscribe = function subscribe(callback) {
    _subscribers.push(callback);
    return {
      unsubscribe: function unsubscribe() {
        _subscribers = _subscribers.filter(function (o) {
          return o !== callback;
        });
      }
    };
  };
  return {
    get subscribers() {
      return _subscribers;
    },
    publish: publish,
    subscribe: subscribe
  };
}
function useFormPubSub() {
  var formRef = useRef();
  if (!formRef.current) {
    var pubSub = createFormPubSub();
    formRef.current = pubSub;
  }
  return formRef.current;
}

export { useFormPubSub as default };
